import React, { PureComponent } from 'react'

export class ResumoGeral extends PureComponent {
  render() {
    return (
      <div>ResumoGeral</div>
    )
  }
}

export default ResumoGeral